import React from 'react';
import { ActionButton } from '../../styles';
import './NoOfferFound.module.css'

// Define the component
const NoOfferFound = ({ heading, description, buttonText, buttonLink }) => {
  return (
    <section className="custom-offer-section">
      <div className="custom-offer-content">
        <h2>{heading}</h2>
        <p>{description}</p>
        <ActionButton to={buttonLink}>{buttonText}</ActionButton>
      </div>
    </section>
  );
};

// Export the component for use in other parts of the app
export default NoOfferFound;
